import { render, staticRenderFns } from "./EcommerceCoursesTable.vue?vue&type=template&id=ddfe141e&scoped=true&"
import script from "./EcommerceCoursesTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceCoursesTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceCoursesTable.vue?vue&type=style&index=0&id=ddfe141e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfe141e",
  null
  
)

export default component.exports